import { collection, addDoc, deleteDoc, doc, setDoc } from 'firebase/firestore'
import { ref } from 'vue'
import firebase from '../../firebase'
import { httpsCallable } from 'firebase/functions'
import updateDevice from '../composables/updateDevice'

const useCollection = (collectionName) => {
  const dbError = ref('')
  const dbPending = ref(false)

  const addDocToDb = async (document, id, admin, deviceToDeviceType) => {
    try {
      dbError.value = ''
      dbPending.value = true
      let docRef

      if (admin) {
        delete document.id
        if (collectionName === 'users' || collectionName === 'doctors' || collectionName === 'admin') {
          const createFirebaseUser = httpsCallable(firebase.functions, 'createFirebaseUser')

          try {
            const res = await createFirebaseUser({ email: document.email, password: document.password, displayName: `${document.firstName} ${document.lastName}` })
            delete document.password
            id = res.data.uid
          } catch (err) {
            dbError.value = err.message
            return
          }
        }

        if (collectionName === 'users' && Object.keys(document.devices).length) {
          for (const device in document.devices) {
            await updateDevice().updateDeviceBasedOnId(device, deviceToDeviceType[device], id)
          }
        }
      }
      if (id) {
        docRef = await setDoc(doc(firebase.db, collectionName, id), document)
      } else {
        docRef = await addDoc(collection(firebase.db, collectionName), document)
        id = docRef.id
      }

      dbPending.value = false

      return { docRef, id }
    } catch (err) {
      console.log(err)
      dbError.value = err.message
    }
  }

  const removeDocFromDb = async (docID) => {
    try {
      dbError.value = ''
      dbPending.value = true
      const docRef = await deleteDoc(doc(firebase.db, collectionName, docID))
      dbPending.value = false
      return docRef
    } catch (err) {
      dbError.value = err.message
    }
  }

  return { dbError, addDocToDb, removeDocFromDb, dbPending }
}

export default useCollection
